import {
  ADD_SOFTWARE_VERSION,
  ADD_SOFTWARE_VERSION_SUCCESSFUL,
  ADD_SOFTWARE_VERSION_FAILED,
} from './actionTypes'

const initialState = {
  error: null,
  message: null,
  loading: false,
}

const SoftwareVersion = (state = initialState, action) => {
  switch (action.type) {
    case ADD_SOFTWARE_VERSION:
      state = {
        ...state,
        softwareVersionData: null,
        loading: true,
        error: null,
      }
      break
    case ADD_SOFTWARE_VERSION_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        softwareVersionData: action.payload,
        error: null,
      }
      break
    case ADD_SOFTWARE_VERSION_FAILED:
      state = {
        ...state,
        softwareVersionData: null,
        loading: false,
        error: action.payload,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default SoftwareVersion
